// extracted by mini-css-extract-plugin
export default {"cls1":"hR2XNbS2lbtLJcclAYGa","cls2":"mRJKmYZeQh1DfFPmsx8l hR2XNbS2lbtLJcclAYGa"};